import { Button, FCX, getRem } from "@datassential/platform-ui-lib";
import { useSelectedKeywordsContext } from "@vms/SelectedKeywords/SelectedKeywordsContext";
import ActionsBar from "@vms/ActionsBar";
import SelectedKeywordsViewsTabs from "@vms/SelectedKeywords/SelectedKeywordsViewsTabs";
import SelectedKeywords from "@vms/SelectedKeywords";
import { useExport } from "@api/useExport";
import { ProfileExportPptRequest } from "@pages/Profile/components/Header/Header";
import { useMemo } from "react";

const HomeActionsBar: FCX<{
    exportPayload: ProfileExportPptRequest;
}> = ({
    exportPayload,
}) => {
    const { selectedKeywordsIds } = useSelectedKeywordsContext();

    const totalExportPayload = useMemo(
        (): ProfileExportPptRequest => ({
            keywordsIds: selectedKeywordsIds,
            ...exportPayload,
        }),
        [exportPayload, selectedKeywordsIds]
    )

    const {
        isLoading: isReportLoading,
        get: downloadReport,
    } = useExport('/api/export/GetPpt', totalExportPayload);

    if (selectedKeywordsIds.length === 0) return null;

    return (
        <ActionsBar>
            <div style={{
                display: 'flex',
                width: '100%',
                alignItems: 'center',
                justifyContent: "center",
                gap: getRem(32),
            }}>
                <SelectedKeywordsViewsTabs className="appears-top del-1"/>
                <SelectedKeywords
                    className="appears-top del-2"
                    style={{
                        width: getRem(190),
                        display: 'flex',
                        alignItems: 'center',
                        justifyContent: "center",
                    }}
                />
                <Button
                    className="appears-top del-3"
                    isDisabled={isReportLoading}
                    onClick={downloadReport}
                    style={{ width: getRem(150) }}
                >
                    {isReportLoading && <div className="load-ellipsis">loading</div>}
                    {!isReportLoading && 'Download'}
                </Button>
            </div>
        </ActionsBar>
    );
}

export default HomeActionsBar;